import React from "react"
import PropTypes from "prop-types"
import NePasManquerItem from "../NePasManquerItem/ne-pas-manquer-item"

const RenderNePasManquer = ({ nePasManquerData }) => {
  return nePasManquerData.map(({ node }) => {
    return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
  })
}

RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}

export default RenderNePasManquer
